export default "__VITE_ASSET__CD0An9wI__"